import styled from '@emotion/styled';
import { withConfig } from 'src/utils/withConfig';
import { setMainLogoWrapper } from 'src/components/Header/Logotype.style';
import { BetStGeorgeCompliancePopupLogo } from 'src/assets/logos/compliancePopup/BetStGeorgeCompliancePopupLogo';
import { BetStGeorgeLogo } from 'src/assets/logos/BetStGeorgeLogo';
import { BetStGeorgeBrandIcon } from 'src/assets/brandIcons/BetStGeorgeBrandIcon';
import { compliancePopupLogoCss } from 'src/domains/common/universes/compliancePopupLogoCss';

export const BetStGeorgeMainLogoWrapper = withConfig(theme => styled('div', { label: 'BetStGeorgeMainLogoWrapper' })`
    ${setMainLogoWrapper(theme)};
`);

export const BetStGeorgeMainLogo = styled(BetStGeorgeLogo, { label: 'BetStGeorgeMainLogo' })`
    height: 32px;
    margin: 0 auto;
    width: 80px;
`;

export const BetStGeorgeBrandIconWrapper = styled(BetStGeorgeBrandIcon, { label: 'BetStGeorgeBrandIconWrapper' })`
    cursor: pointer;
    flex: 0 0 24px;
    margin: 0 auto;
    width: 60px;
`;

export const CompliancePopupLogo = styled(BetStGeorgeCompliancePopupLogo, { label: 'CompliancePopupLogo' })`
    ${compliancePopupLogoCss}
`;
